module.exports = __webpack_public_path__ + "assets/img/14_1002.7c244646.jpg";